import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../ui/Logo';
import { ReviewNote } from '../ui/ReviewNote';
import { aboutLinks, company, contact, contactReviewNotes, mainNav, QUOTE_PATH } from '../../data/site';
import { services } from '../../data/services';
const linkClass = 'text-[15px] text-steel-300 transition-colors duration-150 hover:text-white';
const headingClass = 'font-display text-[15px] font-bold uppercase tracking-[0.16em] text-white';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="border-t-4 border-brand-red bg-charcoal-950 text-steel-300" data-id="element-251" data-mp="3s0kfig6jvogz">
      <div className="mx-auto grid max-w-site gap-14 px-5 py-16 md:px-8 lg:grid-cols-12" data-id="element-252" data-mp="3n43v9x2h1u96">
        <div className="lg:col-span-4" data-id="element-253" data-mp="3j3jwkp292ikx">
          <Logo size="md" data-id="element-254" data-mp="3e2w5y4hxo3r8" />
          <p className="mt-6 max-w-sm text-[15px] leading-relaxed" data-id="element-255" data-mp="3e35ley5cqsio">{company.footerDescription}</p>
          <address className="mt-8 space-y-3 text-[15px] not-italic" data-id="element-256" data-mp="393j8kptfreae">
            <p data-id="element-257" data-mp="2kd4myu609icb">
              <span className="block text-[12px] font-semibold uppercase tracking-[0.14em] text-steel-400" data-id="element-258" data-mp="2kcl4nccg0rxr">
                {contact.phone.label}
              </span>
              <a href={contact.phone.href} className="text-white hover:text-brand-light" data-id="element-259" data-mp="2p5xol966gak6">
                {contact.phone.display}
              </a>
            </p>
            <p data-id="element-260" data-mp="2gcaz20skc3jf">
              <span className="block text-[12px] font-semibold uppercase tracking-[0.14em] text-steel-400" data-id="element-261" data-mp="2gbrgqiz03d4v">
                {contact.mobile.label}
              </span>
              <a href={contact.mobile.href} className="text-white hover:text-brand-light" data-id="element-262" data-mp="381nvnasyvx4x">
                {contact.mobile.display}
              </a>
            </p>
            <p data-id="element-263" data-mp="2z20rwicrmf8p">
              <span className="block text-[12px] font-semibold uppercase tracking-[0.14em] text-steel-400" data-id="element-264" data-mp="2z1hkhvkqr98x">Email</span>
              <a href={`mailto:${contact.email}`} className="text-white hover:text-brand-light" data-id="element-265" data-mp="1impqje7y5txi">
                {contact.email}
              </a>
            </p>
            <p data-id="element-266" data-mp="13kpxlo9ia63c">
              <span className="block text-[12px] font-semibold uppercase tracking-[0.14em] text-steel-400" data-id="element-267" data-mp="13l950b1j5c34">Office</span>
              {contact.physical}
              <br data-id="element-268" data-mp="zjxmsqkzjt4y" />
              {contact.postal}
            </p>
          </address>
          <ReviewNote className="mt-6" data-id="element-269" data-mp="uquv6nzrqtre">{contactReviewNotes.address}</ReviewNote>
        </div>

        <nav aria-label="Footer" className="grid gap-10 sm:grid-cols-3 lg:col-span-8" data-id="element-270" data-mp="pstbq1yfksfe">
          <div data-id="element-271" data-mp="kvb2sbkeyd7e">
            <h2 className={headingClass} data-id="element-272" data-mp="kvt43mlxnhm6">Explore</h2>
            <ul className="mt-5 space-y-3" data-id="element-273" data-mp="funbdos9vucn">
              {mainNav.map(item => <li key={item.label} data-id="element-274" data-mp="btjsetexhi77">
                  <Link to={item.to} className={linkClass} data-id="element-275" data-mp="bulahhud34yf">
                    {item.label}
                  </Link>
                </li>)}
              <li data-id="element-276" data-mp="267ks1giay98c">
                <Link to={QUOTE_PATH} className={linkClass} data-id="element-277" data-mp="2684aqzfs11nf">
                  Request a Quote
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-278" data-mp="216ndddwi3xbl">
            <h2 className={headingClass} data-id="element-279" data-mp="28safh9c7sw51">About Us</h2>
            <ul className="mt-5 space-y-3" data-id="element-280" data-mp="28rhg4tfl58wx">
              {aboutLinks.map(item => <li key={item.to} data-id="element-281" data-mp="2dpspz45vrjf5">
                  <Link to={item.to} className={linkClass} data-id="element-282" data-mp="2dor21z3rn2g0">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>
          <div data-id="element-283" data-mp="2ng3y72wlkeru">
            <h2 className={headingClass} data-id="element-284" data-mp="2niq12p8jm63q">Services</h2>
            <ul className="mt-5 space-y-3" data-id="element-285" data-mp="1pug9z5aap2re">
              {services.map(service => <li key={service.id} data-id="element-286" data-mp="1utarm3wj0l9x">
                  <Link to={`/services#${service.id}`} className={linkClass} data-id="element-287" data-mp="1uuc3gald9bsp">
                    {service.title}
                  </Link>
                </li>)}
            </ul>
          </div>
        </nav>
      </div>

      <div className="border-t border-white/10" data-id="element-288" data-mp="3b6rfufwbeirl">
        <div className="mx-auto flex max-w-site flex-col gap-3 px-5 py-6 text-sm text-steel-400 md:flex-row md:items-center md:justify-between md:px-8" data-id="element-289" data-mp="3b5y5l4y5db4p">
          <p data-id="element-290" data-mp="3dqe1h5rd9itl">
            © {year} {company.legalName}. Company registration {company.registrationNumber}.
          </p>
          <Link to="/privacy-policy" className="transition-colors duration-150 hover:text-white" data-id="element-291" data-mp="38sw329az6lzu">
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>;
}